<template>
  <div id="app">
    <WorkspaceShell v-if="$route.meta.workspace" :key="workspaceSession" />
    <router-view v-else v-slot="{ Component, route }">
      <!-- 始终挂载 keep-alive，本地根据 meta 决定是否缓存 -->
      <keep-alive>
        <component v-if="route.meta.keepAlive" :is="Component" />
      </keep-alive>
      <component v-if="!route.meta.keepAlive" :is="Component" />
    </router-view>
  </div>
</template>

<script>
import { startVideoSubmissionQueue } from '@/utils/videoSubmissionQueue'
import { startAppVersionMonitor } from '@/utils/appVersion'
import { startAuthSessionMonitor } from '@/utils/authSession'
import WorkspaceShell from '@/workspace/WorkspaceShell.vue'
import { startWorkspaceScriptSync } from '@/workspace/scriptSelection'
export default {
  name: 'App',
  components: { WorkspaceShell },
  watch: {
    workspaceSession: {
      immediate: true,
      handler() {
        this.stopScriptSync?.()
        this.stopScriptSync = startWorkspaceScriptSync(this.$router)
      }
    }
  },
  computed: {
    workspaceSession() {
      // Re-evaluate credentials on navigation; logging out destroys all cached views.
      void this.$route.fullPath
      return localStorage.getItem('token') || ''
    }
  },
  mounted() {
    this.stopVersionMonitor = startAppVersionMonitor(this.$router)
    this.stopSessionMonitor = startAuthSessionMonitor(this.$router)
    startVideoSubmissionQueue()
  },
  beforeUnmount() { this.stopVersionMonitor?.(); this.stopSessionMonitor?.(); this.stopScriptSync?.() }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 隐藏浏览器右侧滚动条，但保留滚动功能 */
html,
body {
  height: 100%;
  /* Firefox */
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>
